/**
 * 等级配置页面
 */
import './grade.css';
import React, { Component } from 'react';

class Grade extends Component {
    static defaultProps = {
        value: 0,
        colors: [
            'rgba(179,212,101,1)', //color0
            'rgba(255,97,142,1)', //color1
            'rgba(248,58,75,1)', //color2
            'rgba(235,97,0,1)', //color3
            'rgba(248,58,75,1)', //color4
            'rgba(255,72,182,1)', //color5
            'rgba(255,59,112,1)', //color6
            'rgba(248,58,75,1)', //color7
            'rgba(178,97,255,1)', //color8
            'rgba(200,75,231,1)', //color9
            'rgba(66,142,255,1)', //color10
            'rgba(75,73,230,1)', //color11
            'rgba(178,97,255,1)', //color12
            'rgba(147,43,227,1)', //color13
            'rgba(32,205,255,1)', //color14
            'rgba(47,128,255,1)', //color15
            'rgba(178,97,255,1)', //color16
            'rgba(255,210,0,1)', //color17
            'rgba(255,146,0,1)', //color18
            'rgba(229,2,1,1)', //color19
            'rgba(130,0,189,1)', //color20
            'rgba(248,9,68,1)', //color21
            'rgba(186,4,25,1)', //color22
            'rgba(200,75,231,1)', //color23
            'rgba(153,46,254,1)' //color24
        ]
    }
    constructor(props) {
        super(props);

        this.state = {
            value: props.value
        }
    }

    componentWillMout() {
        this.configColorAndImageArray = [];
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value
        })
    }
    render() {
        let idx = getIndexWithGrade(this.state.value);
        let image = 'grade_' + idx;
        let color = this.props.colors[idx];
        let style = {
            backgroundColor: color
        };
        
        return <div className="ui-grade"><i className={image}></i><em style = { style }>{ this.state.value }</em></div>;
    }
}

function getIndexWithGrade(grade){
    if (grade < 1) {
            return 0;
        }

        var x = grade;

        var n = 0;

        if (x < 44) {
            //等级小于44的时候每个区间的『等级差值』是一个等差数列
            //利用等差数列求和公式和求根公式来计算当前等级所在区间对应到图片存放的地方的坐标；输出0123456.....
            n = (Math.sqrt(9 + 8 * x) - 3) / 2;
        } else {
            //等级大于等于44的时候每个区间的『等级』是一个等差数列
            //利用等差数列通项公式来计算当前等级所在区间对应到图片存放的地方的坐标；输出0123456.....
            n = (x - 34) / 10;
            //与44级之前的对接
            n += 7;
        }

        return Math.floor(n);
}

export default Grade;

export {
    getIndexWithGrade
}



// WEBPACK FOOTER //
// ./js/component/user-ui/grade.js